<template>
  <div>
    <el-button type="primary" @click="bindNewBind(2)">扫码登录</el-button>
    <el-table v-loading="personDataLoading" :data="personData" class="mt-20 mb-20" stripe border max-height="700">
      <el-table-column label="头像" prop="avatar">
        <template slot-scope="scope">
          <div class="avatar-img">
            <img v-if="scope.row.avatar" :src="scope.row.avatar">
            <div v-else-if="scope.row.nickname&&scope.row.nickname.charAt(0)!=='+'" class="wh-100">{{ scope.row.nickname.charAt(0) }}</div>
            <img v-else src="/static/image/module/smart-gc/defaultPhoto.png" alt="" srcset="">
          </div>
        </template>
      </el-table-column>
      <el-table-column label="WA昵称" prop="nickname"></el-table-column>
      <el-table-column label="WA号码" prop="phoneNumber"></el-table-column>
      <el-table-column label="账号状态" prop="phoneStatus">
        <template slot-scope="scope">
          <span class="line" :class="scope.row.phoneStatus==1?'on-line':'off-line'"></span>
          <span>{{ newPhoneStatus(scope.row.phoneStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.phoneStatus==2" type="text" class="mr-16" @click="clickSign(scope.row)">扫码登录</el-button>
          <el-button type="text" @click="clickDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="mt-16" :total="personPageTotal" :current-page="personPage.pageNum" :page-size="personPage.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 50]" @size-change="handleSizePersonPageChange" @current-change="handleCurrentPersonPageChange"></el-pagination>
    <pickupQRCode ref="pickupQRCode" @success="scanSuccess" />
  </div>
</template>

<script>
import { personalUserList, accountDelete } from '@/api/data'
import pickupQRCode from '@/components/pickupQRCodeNew'
export default {
  components: {
    pickupQRCode
  },
  data() {
    return {
      personData: [],
      personDataLoading: false,
      personPageTotal: 0,
      personPage: { pageNum: 1, pageSize: 10 }
    }
  },
  computed: {
    newPhoneStatus() {
      return s => {
        return ['', '在线中', '已离线'][s]
      }
    }
  },
  created() {
    this.personalUserList()
  },
  methods: {
    async bindNewBind() {
      const phoneType = 2
      this.$refs.pickupQRCode.bindNewBind(phoneType)
    },
    personalUserList() {
      this.personDataLoading = true
      const { pageNum, pageSize } = this.personPage
      const subUserId = this.personalId
      personalUserList({ pageNum, pageSize, subUserId, phoneType: 2 }).then((res) => {
        this.personDataLoading = false
        this.personPageTotal = res.data.total
        this.personData = res.data.list
      }).finally(() => {
        this.personDataLoading = false
      })
    },
    handleCurrentPersonPageChange(val) {
      this.personPage.pageNum = val
      this.personalUserList()
    },
    handleSizePersonPageChange(val) {
      this.personPage.pageSize = val
      this.personalUserList()
    },
    clickSign(item) {
      const phoneType = 2
      this.$refs.pickupQRCode.bindNewBind(phoneType, item.uid)
    },
    clickDelete(row) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'el-button--text',
        type: 'warning'
      }).then(() => {
        accountDelete({ uid: row.uid }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.personalUserList()
            this.waAccountOverview(this.personalId)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    scanSuccess() {
      this.personalUserList()
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-img {
  width: 32px;
  height: 32px;
  img {
    max-width: 100%;
    border-radius: 100%;
  }
  div {
    border-radius: 100%;
  }
}
.mt-16{
  margin-top: 16px;
  text-align: right;
}
</style>
